// 처음 로그인한 사람(역할 없음)이 보는 첫 화면 — 사장님이면 업체 만들기, 기사님이면 초대 링크 안내
import { Link } from "react-router-dom";
import { useAuth } from "@/store/auth";

export default function Welcome() {
  const { user, signOut } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-milk-50 px-4 py-8">
      <div className="card p-7 w-full max-w-md space-y-5">
        <div>
          <h1 className="text-xl font-extrabold text-milk-800">무상우유콕에 오신 것을 환영합니다</h1>
          <p className="text-sm text-slate-500 mt-1">로그인 계정: <b>{user?.email}</b></p>
        </div>

        <Link to="/onboarding" className="block rounded-2xl border-2 border-brand-500 p-5 hover:bg-brand-50">
          <div className="text-lg font-bold">🏢 업체 사장님이세요?</div>
          <p className="text-sm text-slate-600 mt-1">업체를 등록하고 시작합니다. 1분이면 됩니다.</p>
          <span className="btn-primary mt-3 w-full">업체 만들기</span>
        </Link>

        <div className="rounded-2xl border border-slate-200 p-5">
          <div className="text-lg font-bold">🚚 기사님이세요?</div>
          <p className="text-sm text-slate-600 mt-1">
            사장님께 받은 <b>초대 링크</b>(카톡·문자)를 눌러 주세요. 구글 로그인 뒤 「등록」을 누르면 배송 화면이 나옵니다.
          </p>
          <p className="text-sm text-slate-500 mt-2">링크를 못 받으셨으면 사장님께 「사용자 권한」 메뉴에서 초대 링크를 보내 달라고 해 주세요.</p>
        </div>

        <div className="text-sm text-slate-500 flex justify-between gap-3 flex-wrap">
          <a className="underline" href="tel:01026085099">도움이 필요하면 010-2608-5099 (평일 9시~18시)</a>
          <button className="underline" onClick={() => signOut()}>다른 계정으로 로그인</button>
        </div>
      </div>
    </div>
  );
}
